import { CrudQueryBuilderError } from "./CrudQueryBuilderError.js";
import { WriteManyRelationBuilder } from "./WriteManyRelationBuilder.js";
import { WriteOneRelationBuilder } from "./WriteOneRelationBuilder.js";
import { GraphQlLiteral } from "../graphQlBuilder/GraphQlLiteral.js";
import { isEmptyObject } from "../utils/isEmptyObject.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class WriteDataBuilder {
  constructor(data) {
    __publicField(this, "data");
    this.data = data || {};
  }
  static resolveData(dataLike) {
    let resolvedData;
    if (dataLike instanceof WriteDataBuilder) {
      resolvedData = dataLike.data;
    } else if (typeof dataLike === "function") {
      resolvedData = dataLike(new WriteDataBuilder()).data;
    } else {
      resolvedData = dataLike;
    }
    if (isEmptyObject(resolvedData)) {
      return void 0;
    }
    return resolvedData;
  }
  set(fieldName, value) {
    return new WriteDataBuilder({ ...this.data, [fieldName]: value });
  }
  many(fieldName, data) {
    const resolvedData = WriteManyRelationBuilder.instantiateFromFactory(data).data;
    return resolvedData === void 0 || resolvedData.length === 0 ? this : new WriteDataBuilder(this.mergeInFreshData(this.data, fieldName, resolvedData));
  }
  one(fieldName, data) {
    const resolvedData = WriteOneRelationBuilder.instantiateFromFactory(data).data;
    return resolvedData === void 0 || isEmptyObject(resolvedData) ? this : new WriteDataBuilder(this.mergeInFreshData(this.data, fieldName, resolvedData));
  }
  mergeInFreshData(original, fieldName, fresh) {
    if (fieldName in original) {
      const existingValue = original[fieldName];
      if (Array.isArray(existingValue)) {
        if (Array.isArray(fresh)) {
          return { ...original, [fieldName]: [...existingValue, ...fresh] };
        }
        throw new CrudQueryBuilderError(`Inconsistent data.`);
      }
      if (Array.isArray(fresh)) {
        throw new CrudQueryBuilderError(`Inconsistent data.`);
      }
      return { ...original, [fieldName]: this.mergeUpdateOne(existingValue, fresh) };
    }
    return { ...original, [fieldName]: fresh };
  }
  mergeUpdateOne(original, fresh) {
    if (original instanceof GraphQlLiteral) {
      if (fresh instanceof GraphQlLiteral) {
        if (original.value === fresh.value) {
          return original;
        }
      }
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (fresh instanceof GraphQlLiteral) {
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (Array.isArray(original)) {
      if (Array.isArray(fresh)) {
        return [...original, ...fresh];
      }
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (Array.isArray(fresh)) {
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (original === null) {
      if (fresh === null) {
        return original;
      }
    }
    if (fresh === null) {
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (typeof original === "object") {
      if (typeof fresh === "object") {
        const composite = { ...original };
        for (const field in fresh) {
          const fromFresh = fresh[field];
          composite[field] = field in composite ? this.mergeUpdateOne(composite[field], fromFresh) : fromFresh;
        }
        return composite;
      }
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (typeof fresh === "object") {
      throw new CrudQueryBuilderError(`Inconsistent data.`);
    }
    if (original === fresh) {
      return original;
    }
    throw new CrudQueryBuilderError(`Inconsistent data.`);
  }
}
export {
  WriteDataBuilder
};
//# sourceMappingURL=WriteDataBuilder.js.map
